module.exports = __webpack_public_path__ + "src/assets/img/icon-login.3515abe7.svg";